<template>
  <TheModal
    :is-open="isShowFormWarningPopUp"
    :mask-closable="false"
    max-width="480px"
    min-height="100px"
  >
    <div class="p-6 tablet:px-0 tablet:py-2">
      <p class="text-sm text-gray-600">
        {{ $t('form.submit-warning') }}
      </p>
      <div class="mt-6 flex justify-end">
        <TheButton
          class="w-full tablet:w-[120px]"
          :title="$t('form.confirm')"
          @click="isShowFormWarningPopUp = false"
        >
          <span class="text-sm">{{ $t('form.confirm') }}</span>
        </TheButton>
      </div>
    </div>
  </TheModal>
</template>

<script setup lang="ts">
  const mainStore = useMainStore();
  const { isShowFormWarningPopUp } = storeToRefs(mainStore);
</script>
